__turbopack_context__.v({
  "container": "_6TE7kG_container",
  "context": "_6TE7kG_context",
  "logo": "_6TE7kG_logo",
  "quote": "_6TE7kG_quote",
  "stamp": "_6TE7kG_stamp",
});
